import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { SettingsService } from './services/settings.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.css']
})

export class AppComponent implements OnInit {

  constructor(private router: Router, public settingsService: SettingsService) { }

  globalLinks = ["", "/", "/login", "/signup", "/termsofservice", "/privacypolicy", "/resetpassword", "/resetpassword/confirm", "/confirmations/register-confirm", "/confirmations/password-reset"];
  routeHidden: boolean = true;

  ngOnInit() {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        console.log(e.url);
        if (this.globalLinks.findIndex(x=>x==e.url) != -1 || e.url.includes(this.globalLinks[7]) || e.url.includes(this.globalLinks[8])) {
          this.routeHidden = false;
          this.settingsService.routeHidden = false;
        } else {
          this.routeHidden = true;
          this.settingsService.routeHidden = true;
        }
      }
    })
  }

}
